module.exports = __webpack_public_path__ + "media/icon/icon-truck-green-4e6ea352.svg";